module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', {
    ref: "colorPicker",
    staticClass: "ql-layer-menu-item"
  }, [_c('md-button', {
    staticClass: "ql-color-picker-choice",
    style: (_vm.style())
  }, [(!_vm.viewableLayer) ? _c('md-icon', [_vm._v("visibility_off")]) : _vm._e(), _vm._v(" "), (!_vm.viewable) ? _c('md-icon', [_vm._v("speaker_notes_off")]) : _vm._e(), _vm._v(" "), (_vm.viewable && !_vm.showNotes) ? _c('md-icon', [_vm._v("hide_image")]) : _c('md-icon')], 1), _vm._v(" "), (_vm.editable) ? _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveTitle.apply(null, arguments)
      },
      "keyup": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.keyPress.apply(null, arguments)
      }
    }
  }, [(!_vm.editing) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.edit()
      }
    }
  }, [_vm._v(_vm._s(_vm.layer.title) + " "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("click to edit title")])], 1) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('md-input-container', [_c('md-input', {
    attrs: {
      "value": _vm.layer.title
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    },
    model: {
      value: (_vm.layer.title),
      callback: function($$v) {
        _vm.$set(_vm.layer, "title", $$v)
      },
      expression: "layer.title"
    }
  })], 1) : _vm._e()], 1) : _c('span', {
    staticStyle: {
      "width": "100%",
      "padding-left": "15px",
      "overflow": "hidden",
      "white-space": "nowrap",
      "text-overflow": "ellipsis"
    }
  }, [_vm._v(" " + _vm._s(_vm.layer.title) + "\n        "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("No Edit Permissions")])], 1), _vm._v(" "), (_vm.editing) ? _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveTitle.apply(null, arguments)
      }
    }
  }, [_c('md-icon', [_vm._v("save")])], 1) : _vm._e(), _vm._v(" "), _c('md-list-expand', [_c('md-list', {
    staticClass: "sub-list"
  }, [_c('md-list-item', {
    staticClass: "sub-list-item"
  }, [(_vm.viewableLayer) ? _c('span', {
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("\n                    Hide Layer\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.viewableLayer) ? _c('span', {
    on: {
      "click": _vm.show
    }
  }, [_vm._v("\n                    Show Layer\n                ")]) : _vm._e()]), _vm._v(" "), _c('md-list-item', {
    staticClass: "sub-list-item"
  }, [(_vm.showCues) ? _c('span', {
    class: _vm.viewableLayer ? 'show-layer' : 'hide-layer',
    on: {
      "click": _vm.hideCue
    }
  }, [_vm._v("\n                    Hide Cues\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.showCues) ? _c('span', {
    class: !_vm.viewableLayer ? 'hide-layer' : 'show-layer',
    on: {
      "click": _vm.showCue
    }
  }, [_vm._v("\n                    Show Cues\n                ")]) : _vm._e()]), _vm._v(" "), _c('md-list-item', {
    staticClass: "sub-list-item"
  }, [(_vm.showNotes) ? _c('span', {
    class: !_vm.viewableLayer ? 'hide-layer' : 'show-layer',
    on: {
      "click": _vm.hideText
    }
  }, [_vm._v("\n                    Hide Notes\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.showNotes) ? _c('span', {
    class: !_vm.viewableLayer ? 'hide-layer' : 'show-layer',
    on: {
      "click": _vm.showText
    }
  }, [_vm._v("\n                    Show Notes\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.editable) ? _c('md-list-item', [_vm._v("\n                Change Color\n                "), _c('md-list-expand', [_c('div', {
    staticClass: "property-box"
  }, [_c('div', {
    staticClass: "property-title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Color")]), _vm._v(" "), _c('div', {
    staticClass: "current-color-box",
    style: ({
      backgroundColor: this.layer.color
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "property-content note_color"
  }, [(_vm.editable) ? [_c('div', {
    staticClass: "color-swatches"
  }, [_c('div', {
    staticClass: "color-box color-box-black",
    on: {
      "click": function($event) {
        return _vm.pickLayerColor('#000000')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-red",
    on: {
      "click": function($event) {
        return _vm.pickLayerColor('#ff0000')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-green",
    on: {
      "click": function($event) {
        return _vm.pickLayerColor('#00ff00')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-blue",
    on: {
      "click": function($event) {
        return _vm.pickLayerColor('#0000ff')
      }
    }
  })]), _vm._v(" "), _c('color-picker', {
    attrs: {
      "value": _vm.layer.color != '#000000' ? _vm.layer.color : '#FF0000'
    },
    on: {
      "input": _vm.pickColor
    }
  }), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("click to change color theme")])] : _vm._e()], 2)])])], 1) : _vm._e(), _vm._v(" "), _c('md-list-item', [_vm._v("\n                Edit Cue Properties\n                "), _c('md-list-expand', [_c('div', {
    staticClass: "property-box"
  }, [_c('span', {
    staticClass: "property-title"
  }, [_vm._v("Cue Placement:")]), _vm._v(" "), _c('div', {
    staticClass: "property-content"
  }, [_c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "mdValue": "left"
    },
    on: {
      "change": _vm.changeCueReplacement
    },
    model: {
      value: (_vm.defaultCuePlacement),
      callback: function($$v) {
        _vm.defaultCuePlacement = $$v
      },
      expression: "defaultCuePlacement"
    }
  }, [_vm._v(" Left side of page")]), _vm._v(" "), _c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "mdValue": "right"
    },
    on: {
      "change": _vm.changeCueReplacement
    },
    model: {
      value: (_vm.defaultCuePlacement),
      callback: function($$v) {
        _vm.defaultCuePlacement = $$v
      },
      expression: "defaultCuePlacement"
    }
  }, [_vm._v(" Right side of page")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "property-box"
  }, [_c('span', {
    staticClass: "property-title"
  }, [_vm._v("Visible in cue:")]), _vm._v(" "), _c('div', {
    staticClass: "property-content"
  }, [_c('md-checkbox', {
    on: {
      "change": _vm.changeHeaderBox
    },
    model: {
      value: (_vm.layerHeaderBox.layerName),
      callback: function($$v) {
        _vm.$set(_vm.layerHeaderBox, "layerName", $$v)
      },
      expression: "layerHeaderBox.layerName"
    }
  }, [_vm._v("Layer Name")]), _vm._v(" "), _c('md-checkbox', {
    on: {
      "change": _vm.changeHeaderBox
    },
    model: {
      value: (_vm.layerHeaderBox.title),
      callback: function($$v) {
        _vm.$set(_vm.layerHeaderBox, "title", $$v)
      },
      expression: "layerHeaderBox.title"
    }
  }, [_vm._v("Number/Title")]), _vm._v(" "), _c('md-checkbox', {
    on: {
      "change": _vm.changeHeaderBox
    },
    model: {
      value: (_vm.layerHeaderBox.label),
      callback: function($$v) {
        _vm.$set(_vm.layerHeaderBox, "label", $$v)
      },
      expression: "layerHeaderBox.label"
    }
  }, [_vm._v("Label")]), _vm._v(" "), _c('md-checkbox', {
    on: {
      "change": function($event) {
        return _vm.changeHeaderBox('time')
      }
    },
    model: {
      value: (_vm.layerHeaderBox.time),
      callback: function($$v) {
        _vm.$set(_vm.layerHeaderBox, "time", $$v)
      },
      expression: "layerHeaderBox.time"
    }
  }, [_vm._v("Time")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "property-box"
  }, [_c('span', {
    staticClass: "property-title"
  }, [_vm._v("Cue Size:")]), _vm._v(" "), _c('vue-slider', {
    attrs: {
      "min": 8,
      "max": 24
    },
    on: {
      "change": _vm.changeTitleFontSize
    },
    model: {
      value: (_vm.titleFontSize),
      callback: function($$v) {
        _vm.titleFontSize = $$v
      },
      expression: "titleFontSize"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "property-box"
  }, [_c('span', {
    staticClass: "property-title"
  }, [_vm._v("Resizable Box Opacity:")]), _vm._v(" "), _c('vue-slider', {
    on: {
      "change": _vm.changeBoxOpacity
    },
    model: {
      value: (_vm.layerBoxOpacity),
      callback: function($$v) {
        _vm.layerBoxOpacity = $$v
      },
      expression: "layerBoxOpacity"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "property-box"
  }, [_c('span', {
    staticClass: "property-title"
  }, [_vm._v("Cue Line Opacity:")]), _vm._v(" "), _c('vue-slider', {
    on: {
      "change": _vm.changeLineOpacity
    },
    model: {
      value: (_vm.cueLineOpacity),
      callback: function($$v) {
        _vm.cueLineOpacity = $$v
      },
      expression: "cueLineOpacity"
    }
  })], 1), _vm._v(" "), (_vm.editable) ? _c('div', {
    staticClass: "property-box"
  }, [_c('md-switch', {
    staticClass: "md-primary",
    model: {
      value: (_vm.autoNumbering),
      callback: function($$v) {
        _vm.autoNumbering = $$v
      },
      expression: "autoNumbering"
    }
  }, [_vm._v("Auto Numbering")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Applies only to cues you create")]), _vm._v(" "), (_vm.autoNumbering) ? _c('div', {
    staticClass: "property-content"
  }, [_c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.autoNumberFieldLabel))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    on: {
      "input": _vm.changeAutoNumberStart,
      "focus": function($event) {
        _vm.autoNumberStartFocused = true
      },
      "blur": function($event) {
        _vm.autoNumberStartFocused = false
      }
    },
    model: {
      value: (_vm.autoNumberStart),
      callback: function($$v) {
        _vm.autoNumberStart = $$v
      },
      expression: "autoNumberStart"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Interval*")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    on: {
      "input": _vm.changeAutoNumberInterval
    },
    model: {
      value: (_vm.autoNumberInterval),
      callback: function($$v) {
        _vm.autoNumberInterval = $$v
      },
      expression: "autoNumberInterval"
    }
  })], 1), _vm._v(" "), (_vm.autoNumberSeedInvalid) ? _c('p', {
    staticClass: "error"
  }, [_vm._v("Enter a number to begin auto-numbering.")]) : (_vm.autoNumberIntervalInvalid) ? _c('p', {
    staticClass: "error"
  }, [_vm._v("Interval must be a number greater than 0.")]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('div', {
    staticClass: "property-box"
  }, [_c('span', {
    staticClass: "property-title"
  }, [_vm._v("Attributes:")]), _vm._v(" "), _c('div', {
    staticClass: "property-content"
  }, [_vm._l((_vm.attributeGroups), function(group) {
    return _c('div', {
      key: group.key,
      staticClass: "property-box"
    }, [_c('div', {
      staticClass: "property-check"
    }, [_c('span', {
      staticClass: "property-title"
    }, [_vm._v(_vm._s(group.label))]), _vm._v(" "), _c('span', [_c('md-checkbox', {
      key: group.key,
      on: {
        "change": function($event) {
          return _vm.changeGroupChecked(group)
        }
      },
      model: {
        value: (group.checked),
        callback: function($$v) {
          _vm.$set(group, "checked", $$v)
        },
        expression: "group.checked"
      }
    }, [_vm._v("Check All")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "property-content"
    }, _vm._l((group.attributes), function(attr) {
      return _c('md-checkbox', {
        key: attr,
        on: {
          "change": function($event) {
            return _vm.changeAttributes(attr)
          }
        },
        model: {
          value: (_vm.attributes[attr]),
          callback: function($$v) {
            _vm.$set(_vm.attributes, attr, $$v)
          },
          expression: "attributes[attr]"
        }
      }, [_vm._v(_vm._s(_vm.cueAttributes[attr]))])
    }), 1)])
  }), _vm._v(" "), _c('div', {
    key: "layerUserDefined",
    staticClass: "property-box"
  }, [_c('div', {
    staticClass: "property-check"
  }, [_c('span', {
    staticClass: "property-title"
  }, [_vm._v("User Defined")])]), _vm._v(" "), _c('div', {
    staticClass: "property-content"
  }, _vm._l((_vm.userDefined), function(attr, index) {
    return (_vm.editable) ? _c('form', {
      key: index,
      staticClass: "user-defined-form",
      attrs: {
        "novalidate": ""
      },
      on: {
        "submit": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.saveTitleUserDefined.apply(null, arguments)
        }
      }
    }, [_c('md-checkbox', {
      staticClass: "user-defined-checkbox",
      on: {
        "change": function($event) {
          return _vm.editUserDefined(index)
        }
      },
      model: {
        value: (attr.value),
        callback: function($$v) {
          _vm.$set(attr, "value", $$v)
        },
        expression: "attr.value"
      }
    }), _vm._v(" "), (_vm.editingActiveUserDefined !== index && attr.label !== '') ? _c('span', {
      staticClass: "black",
      on: {
        "click": function($event) {
          return _vm.editUserDefined(index)
        }
      }
    }, [_vm._v(_vm._s(attr.label) + " ")]) : (_vm.editingActiveUserDefined !== index && attr.label === '') ? _c('span', {
      staticClass: "gray",
      on: {
        "click": function($event) {
          return _vm.editUserDefined(index)
        }
      }
    }, [_vm._v("User " + _vm._s(index.replaceAll(/\D+/g, '')))]) : _vm._e(), _vm._v(" "), (_vm.editingActiveUserDefined !== index) ? _c('md-tooltip', {
      attrs: {
        "md-direction": "top"
      }
    }, [_vm._v("click to edit title")]) : _vm._e(), _vm._v(" "), (_vm.editingUserDefined && _vm.editingActiveUserDefined === index) ? _c('md-input-container', {
      staticClass: "user-defined"
    }, [_c('md-input', {
      staticClass: "user-defined-input",
      attrs: {
        "id": ("user-defined-input-" + index),
        "value": attr.label
      },
      on: {
        "blur": function($event) {
          return _vm.saveTitleUserDefined(index)
        }
      },
      model: {
        value: (attr.label),
        callback: function($$v) {
          _vm.$set(attr, "label", $$v)
        },
        expression: "attr.label"
      }
    })], 1) : _vm._e()], 1) : _vm._e()
  }), 0)])], 2), _vm._v(" "), _c('div', {
    staticClass: "property-action"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.uncheckAllAttrs.apply(null, arguments)
      }
    }
  }, [_vm._v("Uncheck All")])], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('md-list-item', [_vm._v("\n                Edit Note Properties\n                "), _c('md-list-expand', [(_vm.editable && false) ? _c('div', {
    staticClass: "property-box"
  }, [_c('span', {
    staticClass: "property-title"
  }, [_vm._v("Default Text Tool:")]), _vm._v(" "), _c('div', {
    staticClass: "property-content"
  }, [_c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "mdValue": "text"
    },
    on: {
      "change": _vm.changeTextTool
    },
    model: {
      value: (_vm.layer.defaultTextTool),
      callback: function($$v) {
        _vm.$set(_vm.layer, "defaultTextTool", $$v)
      },
      expression: "layer.defaultTextTool"
    }
  }, [_vm._v(" Text Tool")]), _vm._v(" "), _c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "mdValue": "highlight"
    },
    on: {
      "change": _vm.changeTextTool
    },
    model: {
      value: (_vm.layer.defaultTextTool),
      callback: function($$v) {
        _vm.$set(_vm.layer, "defaultTextTool", $$v)
      },
      expression: "layer.defaultTextTool"
    }
  }, [_vm._v(" Highlight Tool")]), _vm._v(" "), _c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "mdValue": "line"
    },
    on: {
      "change": _vm.changeTextTool
    },
    model: {
      value: (_vm.layer.defaultTextTool),
      callback: function($$v) {
        _vm.$set(_vm.layer, "defaultTextTool", $$v)
      },
      expression: "layer.defaultTextTool"
    }
  }, [_vm._v(" Line Tool")]), _vm._v(" "), _c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "mdValue": "stamp"
    },
    on: {
      "change": _vm.changeTextTool
    },
    model: {
      value: (_vm.layer.defaultTextTool),
      callback: function($$v) {
        _vm.$set(_vm.layer, "defaultTextTool", $$v)
      },
      expression: "layer.defaultTextTool"
    }
  }, [_vm._v(" Stamp Tool")]), _vm._v(" "), _c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "mdValue": "count"
    },
    on: {
      "change": _vm.changeTextTool
    },
    model: {
      value: (_vm.layer.defaultTextTool),
      callback: function($$v) {
        _vm.$set(_vm.layer, "defaultTextTool", $$v)
      },
      expression: "layer.defaultTextTool"
    }
  }, [_vm._v(" Count Tool")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "property-box"
  }, [_c('div', {
    staticClass: "md-input-container md-theme-default md-has-select md-has-value"
  }, [_c('label', {
    attrs: {
      "for": "fontFamily"
    }
  }, [_vm._v("Default Font Family:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.layer.fontFamily),
      expression: "layer.fontFamily"
    }],
    staticClass: "md-select md-theme-default",
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "id": "fontFamily",
      "disabled": !_vm.editable
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.layer, "fontFamily", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFontFamily]
    }
  }, [_c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    domProps: {
      "value": 'Arial'
    }
  }, [_vm._v("Arial")]), _vm._v(" "), _c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    domProps: {
      "value": 'Helvetica'
    }
  }, [_vm._v("Helvetica")]), _vm._v(" "), _c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    domProps: {
      "value": 'Roboto'
    }
  }, [_vm._v("Roboto")]), _vm._v(" "), _c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    domProps: {
      "value": 'Times New Roman'
    }
  }, [_vm._v("Times New Roman")]), _vm._v(" "), _c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    domProps: {
      "value": 'Times'
    }
  }, [_vm._v("Times")]), _vm._v(" "), _c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    domProps: {
      "value": 'Courier New'
    }
  }, [_vm._v("Courier New")]), _vm._v(" "), _c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    domProps: {
      "value": 'Courier'
    }
  }, [_vm._v("Courier")]), _vm._v(" "), _c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    domProps: {
      "value": 'Verdana'
    }
  }, [_vm._v("Verdana")]), _vm._v(" "), _c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    domProps: {
      "value": 'Georgia'
    }
  }, [_vm._v("Georgia")]), _vm._v(" "), _c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    domProps: {
      "value": 'Palatino'
    }
  }, [_vm._v("Palatino")]), _vm._v(" "), _c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    domProps: {
      "value": 'Garamond'
    }
  }, [_vm._v("Garamond")]), _vm._v(" "), _c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    domProps: {
      "value": 'Bookman'
    }
  }, [_vm._v("Bookman")]), _vm._v(" "), _c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    domProps: {
      "value": 'Comic Sans MS'
    }
  }, [_vm._v("Comic Sans MS")]), _vm._v(" "), _c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    domProps: {
      "value": 'Trebuchet MS'
    }
  }, [_vm._v("Trebuchet MS")]), _vm._v(" "), _c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    domProps: {
      "value": 'Arial Black'
    }
  }, [_vm._v("Arial Black")]), _vm._v(" "), _c('option', {
    staticClass: "md-list-item md-menu-item md-option",
    domProps: {
      "value": 'Impact'
    }
  }, [_vm._v("Impact")])])])]), _vm._v(" "), _c('div', {
    staticClass: "property-box note-property-box"
  }, [_c('div', {
    staticClass: "md-input-container md-theme-default md-has-select md-has-value"
  }, [_c('label', {
    attrs: {
      "for": "fontSize"
    }
  }, [_vm._v("Default Font Size:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.layer.textFontSize),
      expression: "layer.textFontSize"
    }],
    staticClass: "md-select md-theme-default",
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "id": "fontSize",
      "disabled": !_vm.editable,
      "aria-label": "Default Font Size"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.layer, "textFontSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeTextFontSize]
    }
  }, _vm._l(([8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24]), function(size) {
    return _c('option', {
      key: size,
      staticClass: "md-list-item md-menu-item md-option",
      domProps: {
        "value": size
      }
    }, [_c('span', {
      staticClass: "md-select-value"
    }, [_vm._v(_vm._s(size))])])
  }), 0)]), _vm._v(" "), _c('md-button-toggle', [_c('md-button', {
    staticClass: "md-icon-button",
    class: {
      'md-toggle': _vm.layer.defaultBold
    },
    attrs: {
      "disabled": !_vm.editable
    },
    on: {
      "click": _vm.changeTextBold
    }
  }, [_c('md-icon', [_vm._v("format_bold")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    class: {
      'md-toggle': _vm.layer.defaultItalic
    },
    attrs: {
      "disabled": !_vm.editable
    },
    on: {
      "click": _vm.changeTextItalic
    }
  }, [_c('md-icon', [_vm._v("format_italic")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "property-box"
  }, [_c('span', {
    staticClass: "property-title"
  }, [_vm._v("Text and Stamp Background")]), _vm._v(" "), _c('div', {
    staticClass: "property-content"
  }, [_c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "mdValue": "solid"
    },
    on: {
      "change": _vm.changeTextStampBackground
    },
    model: {
      value: (_vm.defaultTextStampBackground),
      callback: function($$v) {
        _vm.defaultTextStampBackground = $$v
      },
      expression: "defaultTextStampBackground"
    }
  }, [_vm._v(" Solid")]), _vm._v(" "), _c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "mdValue": "nofill"
    },
    on: {
      "change": _vm.changeTextStampBackground
    },
    model: {
      value: (_vm.defaultTextStampBackground),
      callback: function($$v) {
        _vm.defaultTextStampBackground = $$v
      },
      expression: "defaultTextStampBackground"
    }
  }, [_vm._v(" No Fill")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "property-box"
  }, [_c('span', {
    staticClass: "property-title"
  }, [_vm._v("Default Line Thickness:")]), _vm._v(" "), _c('vue-slider', {
    attrs: {
      "min": 1,
      "max": 5
    },
    on: {
      "change": _vm.changeLineThikness
    },
    model: {
      value: (_vm.layer.lineThikness),
      callback: function($$v) {
        _vm.$set(_vm.layer, "lineThikness", $$v)
      },
      expression: "layer.lineThikness"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "property-box"
  }, [_c('span', {
    staticClass: "property-title"
  }, [_vm._v("Default Stamp Size:")]), _vm._v(" "), _c('vue-slider', {
    attrs: {
      "min": 15,
      "max": 150
    },
    on: {
      "change": _vm.changeStampSize
    },
    model: {
      value: (_vm.layer.stampSize),
      callback: function($$v) {
        _vm.$set(_vm.layer, "stampSize", $$v)
      },
      expression: "layer.stampSize"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "property-box"
  }, [_c('div', {
    staticClass: "property-title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Primary Color")]), _vm._v(" "), _c('div', {
    staticClass: "current-color-box",
    style: ({
      backgroundColor: _vm.layer.primaryColor
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "property-content note_color"
  }, [(_vm.editable && !_vm.layer.matchPrimaryColor) ? [_c('div', {
    staticClass: "color-swatches"
  }, [_c('div', {
    staticClass: "color-box color-box-black",
    on: {
      "click": function($event) {
        return _vm.pickSpecificColor1('#000000')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-red",
    on: {
      "click": function($event) {
        return _vm.pickSpecificColor1('#ff0000')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-green",
    on: {
      "click": function($event) {
        return _vm.pickSpecificColor1('#00ff00')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-blue",
    on: {
      "click": function($event) {
        return _vm.pickSpecificColor1('#0000ff')
      }
    }
  })]), _vm._v(" "), _c('color-picker', {
    attrs: {
      "value": _vm.layer.primaryColor != '#000000' ? _vm.layer.primaryColor : '#FF0000'
    },
    on: {
      "input": _vm.pickColor1
    }
  })] : [_c('div', {
    staticClass: "color-swatches"
  }, [_c('div', {
    staticClass: "color-box color-box-black"
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-red"
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-green"
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-blue"
  })]), _vm._v(" "), _c('color-picker', {
    attrs: {
      "value": _vm.layer.primaryColor
    }
  })]], 2), _vm._v(" "), _c('div', [_c('md-checkbox', {
    attrs: {
      "disabled": !_vm.editable
    },
    on: {
      "change": function($event) {
        return _vm.handleMatchLayerColor('primary')
      }
    },
    model: {
      value: (_vm.layer.matchPrimaryColor),
      callback: function($$v) {
        _vm.$set(_vm.layer, "matchPrimaryColor", $$v)
      },
      expression: "layer.matchPrimaryColor"
    }
  }, [_vm._v("Match Layer Color")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "property-box"
  }, [_c('div', {
    staticClass: "property-title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Secondary Color")]), _vm._v(" "), _c('div', {
    staticClass: "current-color-box",
    style: ({
      backgroundColor: _vm.layer.secondaryColor
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "property-content note_color"
  }, [(_vm.editable && !_vm.layer.matchSecondaryColor) ? [_c('div', {
    staticClass: "color-swatches"
  }, [_c('div', {
    staticClass: "color-box color-box-black",
    on: {
      "click": function($event) {
        return _vm.pickSpecificColor2('#000000')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-red",
    on: {
      "click": function($event) {
        return _vm.pickSpecificColor2('#ff0000')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-green",
    on: {
      "click": function($event) {
        return _vm.pickSpecificColor2('#00ff00')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-blue",
    on: {
      "click": function($event) {
        return _vm.pickSpecificColor2('#0000ff')
      }
    }
  })]), _vm._v(" "), _c('color-picker', {
    attrs: {
      "value": _vm.layer.secondaryColor != '#000000' ? _vm.layer.secondaryColor : '#FF0000'
    },
    on: {
      "input": _vm.pickColor2
    }
  })] : [_c('div', {
    staticClass: "color-swatches"
  }, [_c('div', {
    staticClass: "color-box color-box-black"
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-red"
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-green"
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-blue"
  })]), _vm._v(" "), _c('color-picker', {
    attrs: {
      "value": _vm.layer.secondaryColor
    }
  })]], 2), _vm._v(" "), _c('div', [_c('md-checkbox', {
    attrs: {
      "disabled": !_vm.editable
    },
    on: {
      "change": function($event) {
        return _vm.handleMatchLayerColor('secondary')
      }
    },
    model: {
      value: (_vm.layer.matchSecondaryColor),
      callback: function($$v) {
        _vm.$set(_vm.layer, "matchSecondaryColor", $$v)
      },
      expression: "layer.matchSecondaryColor"
    }
  }, [_vm._v("Match Layer Color")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "property-box"
  }, [_c('div', {
    staticClass: "property-title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Highlight Color")]), _vm._v(" "), _c('div', {
    staticClass: "current-color-box",
    style: ({
      backgroundColor: _vm.layer.highlightColor
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "property-content note_color"
  }, [(_vm.editable && !_vm.layer.matchHighlightColor) ? [_c('div', {
    staticClass: "color-swatches"
  }, [_c('div', {
    staticClass: "color-box color-box-black",
    on: {
      "click": function($event) {
        return _vm.pickSpecificColor3('#000000')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-red",
    on: {
      "click": function($event) {
        return _vm.pickSpecificColor3('#ff0000')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-green",
    on: {
      "click": function($event) {
        return _vm.pickSpecificColor3('#00ff00')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-blue",
    on: {
      "click": function($event) {
        return _vm.pickSpecificColor3('#0000ff')
      }
    }
  })]), _vm._v(" "), _c('color-picker', {
    attrs: {
      "value": _vm.layer.highlightColor != '#000000' ? _vm.layer.highlightColor : '#FF0000'
    },
    on: {
      "input": _vm.pickColor3
    }
  })] : [_c('div', {
    staticClass: "color-swatches"
  }, [_c('div', {
    staticClass: "color-box color-box-black"
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-red"
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-green"
  }), _vm._v(" "), _c('div', {
    staticClass: "color-box color-box-blue"
  })]), _vm._v(" "), _c('color-picker', {
    attrs: {
      "value": _vm.layer.highlightColor
    }
  })]], 2), _vm._v(" "), _c('div', [_c('md-checkbox', {
    attrs: {
      "disabled": !_vm.editable
    },
    on: {
      "change": function($event) {
        return _vm.handleMatchLayerColor('highlight')
      }
    },
    model: {
      value: (_vm.layer.matchHighlightColor),
      callback: function($$v) {
        _vm.$set(_vm.layer, "matchHighlightColor", $$v)
      },
      expression: "layer.matchHighlightColor"
    }
  }, [_vm._v("Match Layer Color")])], 1)])])], 1), _vm._v(" "), (_vm.editable && !this.project.isSample) ? _c('md-list-item', {
    on: {
      "click": _vm.deleteLayer
    }
  }, [_vm._v("\n                Delete this layer\n                "), _c('md-icon', [_vm._v("delete")])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-840033be","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layers/layer.vue
// module id = 1273
// module chunks = 21